// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YVNj5","container":"styles_container__Tolk1","title":"styles_title__X5+XQ","navbar":"styles_navbar__lAciF","link":"styles_link__1ua8O"};